module.exports = __webpack_public_path__ + "static/media/dubai-2.30936202.jpg";